import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    categories: [],
    category: null,
    links: null,
    meta: null,
    filter: {
      buId: '',
      keyword: '',
      status: '',
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.filter = {
        buId: '',
        keyword: '',
        status: '',
      };
      state.categories = [];
      state.category = null;
    },
    SET_CATEGORIES(state, data) {
      state.categories = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_CATEGORY(state, data) {
      state.category = data;
    },
  },

  getters: {
    categories(state) {
      return state.categories;
    },
    category(state) {
      return state.category;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setCategory({ commit }, data) {
      commit('SET_CATEGORY', data);
    },

    find({ commit, state }) {
      let url = `/product_categories?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('Category'));
          return response.body;
        })
        .then((response) => {
          commit('SET_CATEGORIES', response);
        });
    },

    findById({ commit }, id) {
      return http(`/product_categories/${id}`)
        .then((response) => response.body)
        .then(typeAs('Category'))
        .then((item) => {
          commit('SET_CATEGORY', item);
        });
    },

    destroy(_, id) {
      return http(`/product_categories/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    publish(_, data) {
      const request = http('/product_categories/publish', { method: 'PUT', data });

      return request.then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/product_categories/${id}`, { method: 'PUT', data })
        : http('/product_categories', { method: 'POST', data });

      return request.then((response) => response.body);
    },

    allByBu(_, id) {
      const request = id
        ? http(`/bus/${id}/product_categories`)
        : http('/product_categories/all');
      return request.then((response) => response.body);
    },

    getCategoriesAndSubcategoy(_, buId) {
      return http(`/categories_subcategoy?bu_id=${buId}`)
        .then((response) => response.body);
    },
  },
};
